import React, { useContext } from 'react';
import HeadingBuilder from './HeadingBuilder';
import CircleLink from '../components/CircleLink';
import { useUtils } from "../hooks/useUtils";
import { ShopperContext } from '../context/shopper'

export const CircleRow = ( {circle} ) => {
  const { circleShoppers, shopper } = useContext(ShopperContext);
  const { is_shopper_a_circle_admin,
          getCountryCodeIfGT1,
          is_shopper_leader_of_this_circle } = useUtils();

  const if_shopper_is_circle_admin = is_shopper_a_circle_admin({
    cShoppers: circleShoppers, circle_id: circle.id, shopper_id: shopper.id
  });

  const if_shopper_is_circle_leader = is_shopper_leader_of_this_circle({
    circle: circle, shopper_id: shopper.id
  });

  return (
    <tr>
      <td>
        <CircleLink circle = {circle} />
        { if_shopper_is_circle_leader
         ? ' #'
         : if_shopper_is_circle_admin
          ? ' *'
          : ''
        }
      </td>
      <td>
        <HeadingBuilder
          containerType  = "container-left"
          headingText    = {
                       circle.xip_code + getCountryCodeIfGT1({
                         shopper, countryCode: circle.country, inString: true
                       })
                            }
          // the Circle's postal_code and maybe its country
        />
      </td>
    </tr>
  )
}

export default CircleRow